import { Badge as e } from "../Badge/Badge.mjs";
import { styled as t } from "styled-components";
//#region src/components/VerifiedIdentityBadge/VerifiedIdentityBadge.styled.ts
var n = t(e)`
    max-width: 100%;
`, r = t.span`
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
//#endregion
export { n as TruncatingBadge, r as TruncatingLabel };
